import { createContext, useContext } from "react";

const AnalyticsContext = createContext<
  | {
      enableAnalytics: boolean;
    }
  | undefined
>(undefined);

export const AnalyticsContextProvider = ({
  enableAnalytics,
  children,
}: {
  enableAnalytics: boolean;
  children: React.ReactNode;
}): JSX.Element => {
  return (
    <AnalyticsContext.Provider value={{ enableAnalytics }}>
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalyticsContext = () => {
  const context = useContext(AnalyticsContext);

  if (context === undefined) {
    throw new Error(
      "useAnalyticsContext must be used within an AnalyticsContextProvider"
    );
  }

  return context;
};
